































import { Component, Mixins, Watch } from "vue-property-decorator";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import HasValidation from "@/mixins/HasValidation";

// Types
import { IContractProduct } from "@/models/contracts";

@Component
export default class CProdCustomLabelForm extends Mixins(
  CProdInjectorMixin,
  HasValidation
) {
  // Data

  public isProcessing = false;
  public form: Pick<IContractProduct, "client_label"> = {};

  // Life-cycle methods

  public created() {
    this.initialiseForm();
  }

  // Methods

  public initialiseForm() {
    this.form = this.initForm();
  }

  public initForm() {
    return { client_label: this.cProdData.contractProduct.client_label || "" };
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$cProdMethods.update(this.form);
      await this.$cProdMethods.reloadData();

      this.initialiseForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.cprod.entity_successfully_updated", {
          entity: this.$_.upperFirst(this.cProdData.entity)
        })
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.initialiseForm();
  }

  // Computed

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsChanged || this.hasErrors;
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  // Watchers

  @Watch("formIsChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.formIsChanged);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);
  }
}
